import {
    faAlignLeft,
    faArrowUp19,
    faCalculator,
    faEye,
    faEyeLowVision,
    faHashtag,
    faI,
    faLocationDot,
    faMagnifyingGlass,
    faPercent,
    faRuler,
    faTag,
} from '@fortawesome/sharp-regular-svg-icons';
import { NamedIconsType } from '../../types/types';

export const cegidComptability: NamedIconsType = {
    props: {
        icon: faCalculator,
    },
    name: 'cegid',
    displayName: 'Comptabilité CEGID',
};

export const detailIcon: NamedIconsType = {
    props: {
        icon: faMagnifyingGlass,
    },
    name: 'detail',
    displayName: 'Détail',
};
export const priceIcon: NamedIconsType = {
    props: {
        icon: faTag,
    },
    name: 'price',
    displayName: 'Prix',
};

export const identifierIcon: NamedIconsType = {
    props: {
        icon: faI,
    },
    name: 'identifier',
    displayName: 'Identifiant',
};

export const unitIcon: NamedIconsType = {
    props: {
        icon: faRuler,
    },
    name: 'unit',
    displayName: 'Unité',
};

export const codeArticleIcon: NamedIconsType = {
    props: {
        icon: faHashtag,
    },
    name: 'code_article',
    displayName: 'Code article',
};

export const percentIcon: NamedIconsType = {
    props: {
        icon: faPercent,
    },
    name: 'rate',
    displayName: 'Taux',
};

export const visibilityFullIcon: NamedIconsType = {
    props: {
        icon: faEye,
    },
    name: 'visibility_full',
    displayName: 'Visibilité complète',
};

export const visibilityPartialIcon: NamedIconsType = {
    props: {
        icon: faEyeLowVision,
    },
    name: 'visibility_partial',
    displayName: 'Visibilité partielle',
};

export const originIcon: NamedIconsType = {
    props: {
        icon: faLocationDot,
    },
    name: 'origin',
    displayName: 'Origine',
};

export const descriptionIcon: NamedIconsType = {
    props: {
        icon: faAlignLeft,
    },
    name: 'description',
    displayName: 'Description',
};

export const rankIcon: NamedIconsType = {
    props: {
        icon: faArrowUp19,
    },
    name: 'rank',
    displayName: 'Rang',
};

export const offersNamedIcons: NamedIconsType[] = [
    cegidComptability,
    detailIcon,
    priceIcon,
    identifierIcon,
    unitIcon,
    codeArticleIcon,
    percentIcon,
    visibilityFullIcon,
    visibilityPartialIcon,
    originIcon,
    descriptionIcon,
    rankIcon,
];
